import React from "react";
import { Box, Flex, Text, useColorModeValue, Skeleton } from "@chakra-ui/react";
import Card from "../../../../components/card/Card";
import { CustomBarChart } from "../../../../components/charts";

export default function DailyTraffic({ trafficData, isLoading, timeRange }) {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  
  const timeRangeLabels = {
    'today': 'Bugün',
    'yesterday': 'Dün',
    'week': 'Bu Hafta',
    'month': 'Bu Ay'
  };

  const chartData = React.useMemo(() => {
    if (!trafficData?.data?.hourlyTraffic) {
      return [];
    }

    const processed = trafficData.data.hourlyTraffic
      .map(item => ({
        name: `${String(item.hour).padStart(2, '0')}:00`,
        value: item.orderCount || 0,
        hour: item.hour
      }))
      .sort((a, b) => a.hour - b.hour);
    return processed;
  }, [trafficData]);

  const totalOrders = React.useMemo(() => {
    return chartData.reduce((sum, item) => sum + item.value, 0);
  }, [chartData]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Box
          bg="gray.800"
          p="12px"
          borderRadius="6px"
          border="none"
          boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
        >
          <Text color="white" fontSize="sm" fontWeight="500">
            {data.hour}:00 - {data.hour + 1}:00
          </Text>
          <Text color="white" fontSize="sm" fontWeight="700">
            {data.value} Sipariş
          </Text>
        </Box>
      );
    }
    return null;
  };

  return (
    <Card align='center' direction='column' w='100%'>
      <Flex justify='space-between' align='start' px='10px' pt='5px' w="100%">
        <Flex flexDirection='column' align='start' me='20px'>
          <Text color={textColor} fontSize='lg' fontWeight='700'>
            Saatlik Sipariş Trafiği ({timeRangeLabels[timeRange] || 'Bugün'})
          </Text>
          <Flex align='center'>
            <Text color={textColor} fontSize='34px' fontWeight='700' lineHeight='100%'>
              {totalOrders}
            </Text>
            <Text ms='6px' color='secondaryGray.600' fontSize='sm' fontWeight='500'>
              Sipariş
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Box h='240px' mt='auto' w="100%">
        {isLoading ? (
          <Skeleton height='100%' width='100%' />
        ) : (
          <CustomBarChart 
            data={chartData}
            colors={['#E45858']}
            height={240}
            customTooltip={CustomTooltip}
          />
        )}
      </Box>
    </Card>
  );
}